/***********************************
Stock Ticker Module
************************************/

Quad.StockTicker = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

      var path = window.location.href.split( '/' );
      path = path[ 0 ]+'//'+path[ 2 ];

      function getStocks(){

        $.get( path+'/wp-json/investor-relations/v1/quotes/current',
          function( data ){

            Object.keys(data).forEach(function(key){

              if( key == 'bid' ) {

                data[key] = data[key].toFixed(2);

              }

              if( key == 'volume' ){
                data[key] = data[key].toLocaleString( 'en' );
              }

              if( key == 'date' ){

                var date = new Date( data[key] ),
                    day     = date.getDate(),
                    month   = date.getMonth() + 1,
                    year    = date.getFullYear().toString().substr(-2),
                    hour    = date.getHours(),
                    minutes = date.getMinutes(),
                    ampm    = ' a.m.';

                if( minutes < 10 ){
                  minutes = '0'+minutes;
                }

                if( hour > 12 ){
                  hour = hour - 12;
                  ampm = ' p.m.';
                }

                data[key] = month +'/'+ day +'/'+ year +' '+ hour +':'+ minutes + ampm;


              }

              if( data[ 'dayChange' ] < 0 ){
                $('#stock-ticker .stock-icon ').addClass( 'icon-down-arrow' );
              } else {
                $('#stock-ticker .stock-icon ').addClass( 'icon-up-arrow' );
              }

              $( '#stock-ticker .'+key ).text( data[key] );

            });

          }
        );

      }


      getStocks();


      $('#stock-ticker .refresh').click(function(){

        $('.ticker-hide').text('...');

        getStocks();

      });

    }


    // PUBLIC METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    return {

      init: _init

    };

  })();

